export const quizQuestions = [
  // RED LIGHT
  {
    id: "question1",
    videoId: "video1",
    topic: "Traffic_Lights",
    question: "Red Traffic Light Indicates that you need to: ",
    options: [
      "Wait for the green signal",
      "Slow down and proceed if there is no danger ahead",
      "Stop and proceed if there is no danger ahead",
    ],
    correctAnswer: "Stop and proceed if there is no danger ahead",
    descriptionTitle: "RED LIGHT",
    description1:
      "The purpose of a red traffic light signal is to indicate to drivers that they must come to a complete stop at an intersection or a designated point on the road. Red traffic lights serve several important functions in traffic control.",
    description2:
      " 1. Safety: The primary purpose of a red light is to enhance road safety by preventing conflicts between vehicles and pedestrians. It ensures that vehicles from different directions do not enter the intersection simultaneously, reducing the risk of collisions.",
    description3:
      " 2. Traffic Control: Red lights help regulate the flow of traffic at intersections where multiple roads intersect. They allocate right-of-way to different directions of travel, ensuring a smooth and orderly movement of vehicles.",
    description4:
      " 3. Intersection Management: Red lights are essential for managing complex intersections, especially those with high traffic volumes. They allow each stream of traffic to take turns, minimizing congestion and gridlock.",
  },

  // YELLOW LIGHT
  {
    id: "question2",
    videoId: "video2",
    topic: "Traffic_Lights",
    question: "Yellow traffic light means: ",
    options: [
      "Stop",
      "Prepare to stop, red traffic light is about to light up",
      "You can go, but slow down",
    ],
    correctAnswer: "Prepare to stop, red traffic light is about to light up",
    descriptionTitle: "YELLOW LIGHT",
    description1:
      "Yellow lights are a common feature in various contexts, such as traffic signals, warning signs, and other applications. They are characterized by their distinct yellow or amber color, which is typically a bright and vibrant shade of yellow.",
    description2:
      " 1. Warning and Caution: Yellow lights are often used as warning signals to alert people to slow down, exercise caution, or prepare for a change in conditions. In traffic signals, a yellow light indicates that a red light is imminent, signaling drivers to slow down and come to a stop if it's safe to do so. This provides essential information for road safety, helping to prevent accidents at intersections.",
    description3:
      " 2. Visibility and Attention: Yellow lights are highly visible, even in various lighting conditions. Their distinct color helps them stand out and grab attention, making them effective tools for communication. In addition to traffic signals, yellow lights can be found in warning signs, construction zones, and hazard lights on vehicles. This visibility is crucial for alerting people to potential dangers and encouraging them to take appropriate actions.",
  },

  // GREEN LIGHT
  {
    id: "question3",
    videoId: "video3",
    topic: "Traffic_Lights",
    question: "Whenever I see a green traffic light, it means: ",
    options: [
      "I need to stop",
      "Prepare to stop, red traffic light is about to light up",
      "I can go, given I yield to pedestrians first.",
    ],
    correctAnswer: "I can go, given I yield to pedestrians first.",
    descriptionTitle: "GREEN LIGHT",
    description1:
      "A green signal is the indication that you can go ahead and proceed. Before proceeding, you must prioritize and yield to pedestrians that are crossing the road.  There are also times when you will need to turn left or right after a green light. The pedestrians crossing on those turns will have the right of way. So you need to be extra careful and be sure not to block the traffic. When a green signal is accompanied by a flashing left or right green arrow, it means that the vehicle in front of that signal can make a left turn, right turn, or proceed straight.",
  },
];
